export default __webpack_public_path__ + "static/media/tag.61360c4f.svg";